class Seo {

    constructor() {

        this.elements = {
            title_tab: null,
            meta_description: null
        };

        this.init();

    }


    init() {

        if ($('.seo[data-type="title-tab"]').length > 0) {
            this.elements.title_tab = $('.seo[data-type="title-tab"]');
        }

        if ($('.seo[data-type="meta-description"]').length > 0) {
            this.elements.meta_description = $('.seo[data-type="meta-description"]');
        }

        this.events();
    }

    

    events() {
        let self = this;
        
        if (this.elements.title_tab != null) {

            $.each(this.elements.title_tab, function (index, value) {

                self.setTooltipTitle(this, 60);
                
                if ($(this).val().length != 0) {
                    $(this).closest('.input-group').find('.input-group-text').html($(this).val().length + '/60');
                }

                $(this).on('change keyup', function () {
                    $(this).closest('.input-group').find('.input-group-text').html($(this).val().length + '/60');
                    self.setTooltipTitle(this, 60);
                });
            });


        }

        if (this.elements.meta_description != null) {

            $.each(this.elements.meta_description, function (index, value) {
                
                self.setTooltipTitle(this, 156);

                if ($(this).val().length != 0) {
                    self.checkMetaDescription(this);
                }

                $(this).on('change keyup', function () {
                    self.checkMetaDescription(this);
                    self.setTooltipTitle(this, 156);
                });
            });



        }
    }

    checkMetaDescription(item) {
        let color = '#0f5132';
        let bgColor = '#d1e7dd';

        if ($(item).val().length > 156 && $(item).val().length < 320) {
            color = '#664d03';
            bgColor = '#fff3cd';
        } 
        if ($(item).val().length >= 320) {
            color = '#842029';
            bgColor = '#f8d7da';
        }

        $(item).closest('.input-group').find('.input-group-text').html($(item).val().length + '/156');
        $(item).closest('.input-group').find('.input-group-text').css({
            'color': color,
            'background-color': bgColor
        });
    }

    setTooltipTitle(item, max) {

        let length = $(item).val().length

        $(item).closest('.input-group').find('.input-group-append').tooltip().attr('data-original-title', `${length} of ${max} characters used`);
    }
}